import { render, staticRenderFns } from "./prix-equilibre.vue?vue&type=template&id=2b465cbc&scoped=true"
import script from "./prix-equilibre.vue?vue&type=script&lang=js"
export * from "./prix-equilibre.vue?vue&type=script&lang=js"
import style0 from "./prix-equilibre.vue?vue&type=style&index=0&id=2b465cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b465cbc",
  null
  
)

export default component.exports